import Vuex from 'vuex';

export default (moduleName, prefix = null) => {
    let namespace = prefix || moduleName;
    return {
        computed: {
            ...Vuex.mapGetters(moduleName, {
                [`${namespace}_content`]: 'content',
                [`${namespace}_contentType`]: 'contentType',
                [`${namespace}_timestamp`]: 'timestamp',
                [`${namespace}_loading`]: 'loading',
                [`${namespace}_notifications`]: 'notifications',
                [`${namespace}_parent`]: 'parent',
                [`${namespace}_selected`]: 'selected',
                [`${namespace}_status`]: 'status',
                [`${namespace}_path`]: 'path',
                [`${namespace}_query`]: 'query',
            }),

            [namespace]() {
                return {
                    'content': this[`${namespace}_content`],
                    'contentType': this[`${namespace}_contentType`],
                    'timestamp': this[`${namespace}_timestamp`],
                    'loading': this[`${namespace}_loading`],
                    'notifications': this[`${namespace}_notifications`],
                    'parent': this[`${namespace}_parent`],
                    'selected': this[`${namespace}_selected`],
                    'status': this[`${namespace}_status`],
                    'path': this[`${namespace}_path`],
                    'query': this[`${namespace}_query`],
                    'getInitialData': this[`${namespace}_getInitialData`],
                    'getData': this[`${namespace}_getData`],
                    'createData': this[`${namespace}_createData`],
                    'updateBatch': this[`${namespace}_updateBatch`],
                    'updateData': this[`${namespace}_updateData`],
                    'deleteData': this[`${namespace}_deleteData`],
                    'replaceData': this[`${namespace}_replaceData`],
                    'setContent': this[`${namespace}_setContent`],
                    'updateCollection': this[`${namespace}_updateCollection`],
                    'updateParent': this[`${namespace}_updateParent`],
                    'setSelected': this[`${namespace}_setSelected`],
                    'setParent': this[`${namespace}_setParent`],
                    'changePath': this[`${namespace}_changePath`],
                    'changeQuery': this[`${namespace}_changeQuery`],
                    'changeHash': this[`${namespace}_changeHash`],
                }
            }
        },

        methods: {
            ...Vuex.mapActions(moduleName, {
                [`${namespace}_getInitialData`]: 'getInitialData',
                [`${namespace}_getData`]: 'getData',
                [`${namespace}_createData`]: 'createData',
                [`${namespace}_updateBatch`]: 'updateBatch',
                [`${namespace}_updateData`]: 'updateData',
                [`${namespace}_deleteData`]: 'deleteData',
                [`${namespace}_replaceData`]: 'replaceData',
                [`${namespace}_setContent`]: 'setContent',
                [`${namespace}_updateCollection`]: 'updateCollection',
                [`${namespace}_updateParent`]: 'updateParent',
                [`${namespace}_setSelected`]: 'setSelected',
                [`${namespace}_setParent`]: 'setParent',
                [`${namespace}_changePath`]: 'changePath',
                [`${namespace}_changeQuery`]: 'changeQuery',
                [`${namespace}_changeHash`]: 'changeHash',
            }),
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/mixins/Module.js